export const characterList = [
  {
    id: "lin-xiaoyu",
    name: "林小雨",
    nameEn: "Lin Xiaoyu",
    initial: "L",
    work: "春日雨信",
    workId: "spring-rain-letter",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20gentle%20high%20school%20girl%20with%20soft%20brown%20hair%20and%20a%20warm%20smile%2C%20cel%20shaded%20style%2C%20clean%20soft%20blue%20gradient%20background%2C%20detailed%20expressive%20eyes%2C%20high%20quality%20character%20art&width=600&height=600&seq=ch-01&orientation=squarish",
    tags: ["温柔", "文学部", "治愈系"],
    description:
      "春日雨信的女主角，文学部成员，习惯把想说的话写进信里却从不寄出。表面安静，内心却比谁都坚定。她相信等待本身也是一种表达，因此愿意在同一个站台守候三年。",
    relatedCharacters: ["chen-mu", "su-yan"],
    relatedNews: ["music-anime-slice-of-life", "fantasy-worldbuilding-guide"]
  },
  {
    id: "chen-mu",
    name: "陈牧",
    nameEn: "Chen Mu",
    initial: "C",
    work: "春日雨信",
    workId: "spring-rain-letter",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20calm%20young%20man%20with%20dark%20hair%20and%20a%20slight%20smile%2C%20cel%20shaded%20style%2C%20clean%20soft%20blue%20gradient%20background%2C%20detailed%20expressive%20eyes%2C%20high%20quality%20character%20art&width=600&height=600&seq=ch-02&orientation=squarish",
    tags: ["沉默", "转学生", "摄影"],
    description:
      "转学而来的少年，随身带着一台旧相机。他习惯用快门记录下不愿意遗忘的瞬间，却始终不敢面对镜头里最想留住的人。",
    relatedCharacters: ["lin-xiaoyu", "su-yan"],
    relatedNews: ["music-anime-slice-of-life"]
  },
  {
    id: "kael",
    name: "凯尔",
    nameEn: "Kael",
    initial: "K",
    work: "星环彼岸",
    workId: "star-ring-beyond",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20confident%20young%20space%20pilot%20with%20silver%20hair%20and%20a%20determined%20gaze%2C%20cel%20shaded%20style%2C%20clean%20soft%20navy%20gradient%20background%2C%20detailed%20expressive%20eyes%2C%20high%20quality%20character%20art&width=600&height=600&seq=ch-03&orientation=squarish",
    tags: ["队长", "直觉派", "重情"],
    description:
      "探索船的年轻船长，以近乎莽撞的直觉带领船员穿越星环。他从不计算成功率，只在意「有没有人还在等我们回去」。",
    relatedCharacters: ["rei", "hoshino-aki"],
    relatedNews: ["mecha-renaissance-2026", "new-anime-season-preview-2026"]
  },
  {
    id: "rei",
    name: "零",
    nameEn: "Rei",
    initial: "L",
    work: "星环彼岸",
    workId: "star-ring-beyond",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20stoic%20android%20girl%20with%20short%20white%20hair%20and%20glowing%20blue%20eyes%2C%20cel%20shaded%20style%2C%20clean%20soft%20navy%20gradient%20background%2C%20detailed%20character%20art&width=600&height=600&seq=ch-04&orientation=squarish",
    tags: ["人造人", "冷静", "导航员"],
    description:
      "船上唯一的非人类船员，负责全部导航计算。她声称自己不理解情绪，却在每一次危急关头做出了最像「人」的抉择。",
    relatedCharacters: ["kael", "hoshino-aki"],
    relatedNews: ["mecha-renaissance-2026"]
  },
  {
    id: "shirogane",
    name: "白银凉介",
    nameEn: "Shirogane Ryosuke",
    initial: "B",
    work: "破晓之刃",
    workId: "blade-of-dawn",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20fiery%20male%20swordsman%20with%20orange%20hair%20and%20a%20scar%2C%20determined%20expression%2C%20cel%20shaded%20style%2C%20clean%20soft%20navy%20gradient%20background%2C%20detailed%20character%20art&width=600&height=600&seq=ch-05&orientation=squarish",
    tags: ["剑士", "热血", "守护"],
    description:
      "破晓之刃的男主角，出身没落剑道世家。他把「变强」当作唯一目标，直到明白真正的强大是愿意为他人挡下攻击。",
    relatedCharacters: ["kurono", "hoshino-aki"],
    relatedNews: ["animation-fight-scene-craft", "new-anime-season-preview-2026"]
  },
  {
    id: "kurono",
    name: "黑野彻",
    nameEn: "Kurono Toru",
    initial: "H",
    work: "破晓之刃",
    workId: "blade-of-dawn",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20mysterious%20male%20swordsman%20with%20long%20black%20hair%20and%20a%20cold%20serious%20expression%2C%20cel%20shaded%20style%2C%20clean%20soft%20navy%20gradient%20background%2C%20detailed%20character%20art&width=600&height=600&seq=ch-06&orientation=squarish",
    tags: ["对手", "悲剧", "剑鬼"],
    description:
      "与主角亦敌亦友的天才剑客。他背负着家族的血债，把自我放逐当作赎罪，最终在破晓时刻选择了与过去和解。",
    relatedCharacters: ["shirogane"],
    relatedNews: ["animation-fight-scene-craft"]
  },
  {
    id: "hoshino-aki",
    name: "星野爱希",
    nameEn: "Hoshino Aki",
    initial: "X",
    work: "星环彼岸",
    workId: "star-ring-beyond",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20a%20cheerful%20girl%20engineer%20with%20short%20teal%20hair%20and%20goggles%2C%20bright%20smile%2C%20cel%20shaded%20style%2C%20clean%20soft%20navy%20gradient%20background%2C%20detailed%20character%20art&width=600&height=600&seq=ch-07&orientation=squarish",
    tags: ["机械师", "乐天", "发明家"],
    description:
      "船上负责维修的天才工程师，能在十分钟内用废料修好引擎。她把每一次故障都当成新玩具，是团队里最乐观的存在。",
    relatedCharacters: ["kael", "rei"],
    relatedNews: ["mecha-renaissance-2026", "music-anime-slice-of-life"]
  },
  {
    id: "su-yan",
    name: "苏烟",
    nameEn: "Su Yan",
    initial: "S",
    work: "夜行列车",
    workId: "night-train",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20of%20an%20elegant%20mysterious%20woman%20with%20dark%20purple%20hair%20and%20a%20knowing%20smile%2C%20cel%20shaded%20style%2C%20clean%20soft%20navy%20gradient%20background%2C%20detailed%20character%20art&width=600&height=600&seq=ch-08&orientation=squarish",
    tags: ["列车员", "神秘", "情报"],
    description:
      "夜行列车上的检票员，掌握着所有乘客的秘密。她从不主动说谎，却也从不把真相说完整。",
    relatedCharacters: ["lin-xiaoyu", "chen-mu"],
    relatedNews: ["fantasy-worldbuilding-guide", "night-train"]
  }
];